import DragItem from "./DragItem"



class DropItem {

    constructor() {
        this.dropTxt = "........"
        this.dropImg = "default.png"
        this.dragList = []
        this.solvedDragItem=new DragItem();

    }

    addDragItem = (dragItem) => {

        let obj = dragItem.getAsJson()
        let newDragItem = new DragItem()
        newDragItem.initFromJson(obj)
        this.dragList.push(newDragItem)
    }

    removeDragItem = (dragItem) => {

        let index = -1;
        for (let i = 0; i < this.dragList.length; i++) {
            if (dragItem.dragIndex == this.dragList[i].dragIndex) {

                index = i
                break
            }
        }

        if(index!=-1){
            this.dragList.splice(index,1)
        }
    }

    selectDragItem = (dragItem) => {
        if (this.contains(dragItem)) {
            this.removeDragItem(dragItem)
        }
        else {
            this.addDragItem(dragItem)
        }
    }

    contains = (dragItem) => {
        for (let i = 0; i < this.dragList.length; i++) {
            if (dragItem.dragIndex == this.dragList[i].dragIndex)
                return true
        }

        return false
    }


    isAnsewredTrue=()=>{
        let result=false
        for(let j=0;j<this.dragList.length;j++){

            if(this.solvedDragItem.dragIndex==this.dragList[j].dragIndex){
                result=true
            }
           
        }

        return result;
    }

    getAsJson = () => {
        let obj = {}
        obj.dropTxt = this.dropTxt
        obj.dropImg = this.dropImg
        obj.solvedDragItem = this.solvedDragItem.getAsJson()
        obj.dragList = []
        for (let i = 0; i < this.dragList.length; i++) {
            obj.dragList.push(this.dragList[i].getAsJson())
        }

        return obj
    }

    getAvailableAns = () => {
        let ans = "";


        this.dragList.map((dragItem, index) => {
            
            
            console.log(typeof(this.dragList[index].dragTxt))
           
            if (index == this.dragList.length - 1)
                ans += this.dragList[index].dragTxt
            else
                ans += this.dragList[index].dragTxt + " , "
        })

        
        return ans.replace(/<\/?[^>]+>/ig, " ")

    }

   
    initFromJson = (obj) => {

        this.dropTxt = obj.dropTxt
        this.qTxt = obj.qTxt
        this.solvedDragItem.initFromJson(obj.solvedDragItem) 

        this.dropImg = obj.dropImg
        for (let i = 0; i < obj.dragList.length; i++) {
            let dragItem = new DragItem()
            dragItem.initFromJson(obj.dragList[i])
            this.dragList.push(dragItem)
        }
    }


    getReportAsJson=()=>{
        let obj={}
      

        return obj
    }


    initReportFromJson=(obj)=>{
       
    }

}

export default DropItem